import React from 'react'
import { TableCP } from 'submodules/nerit-framework-ui/common/components/table/TableCP'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import { ISummaryRowTP, SummaryTableSCP } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCDashboardUtils'

interface ICPProps {
	data: ISummaryRowTP[]
}

/**
 * Tabela resumo do dashboard QAQC com fonte ampliada e valores em negrito.
 */
export function QAQCSummaryTableCP(props: ICPProps): JSX.Element {
	return (
		<SummaryTableSCP>
			<TableCP<ISummaryRowTP>
				bordered={true}
				showHeader={false}
				data={props.data}
				rowKey={(row) => row.key}
				columns={[
					{
						title: 'Indicador',
						dataIndex: 'label',
					},
					{
						title: 'Quantidade',
						dataIndex: 'value',
						align: 'right',
						render: (val: number) => <TextCP text={val} strong={true} />,
					},
				]}
			/>
		</SummaryTableSCP>
	)
}
